import React, { useContext } from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import {
  Routes as AppRoutes,
  authBasePath,
  protectedAreaBasePath,
} from './routeMapping';
import { Auth } from '../layouts';
import Constants from '../constants';

function AuthRoute() {
  const location = useLocation();

  const { isAuthenticated, role } = useContext(AuthContext);

  const dashboard =
    role === Constants.User.Roles.Admin.id ? protectedAreaBasePath : null;

  if (isAuthenticated) {
    return <Navigate to={dashboard} state={{ from: location }} replace />;
  }

  return (
    <Auth>
      {location.pathname === authBasePath ? (
        <Navigate to={AppRoutes.auth.LOGIN.path} replace />
      ) : (
        <Outlet />
      )}
    </Auth>
  );
}

export default AuthRoute;
